import * as api from '@owl-nest/api-client/latest'
import { Either } from '@owl-nest/monad'

export async function get<EXTRA_FIELDS extends string = ''>(
  userId: number,
  extraFields: EXTRA_FIELDS[] = [],
): Promise<api.ApiResponse<api.Address<EXTRA_FIELDS>[]>> {
  const response = await api.api.get.userAddresses({
    urlParams: { userId: String(userId) },
    getParams: { extra_fields: extraFields.join(',') },
  })

  return response.caseOf({
    left: (failure) => {
      if (failure.status === 401) {
        return Either.right([] as api.Address<EXTRA_FIELDS>[])
      }
      return Either.left(failure)
    },
    right: (success) => {
      const { addresses } = success.body
      return Either.right(addresses as api.Address<EXTRA_FIELDS>[])
    },
  })
}

export async function add<EXTRA_FIELDS extends string = ''>(
  userId: number,
  address: api.CreateAddress,
  extraFields: EXTRA_FIELDS[] = [],
): Promise<api.ApiResponse<api.Address<EXTRA_FIELDS>>> {
  const response = await api.api.post.userAddresses({
    urlParams: { userId: String(userId) },
    getParams: { extra_fields: extraFields.join(',') },
    body: address,
  })

  return response.next((success) => success.body as api.Address<EXTRA_FIELDS>)
}

export async function remove(addressId: number): Promise<api.ApiResponse<void>> {
  const response = await api.api.delete.addresses({
    urlParams: { addressId: String(addressId) },
  })

  return response.next((success) => success.body)
}

export async function update<EXTRA_FIELDS extends string = ''>(
  addressId: number,
  address: api.UpdateAddress,
  extraFields: EXTRA_FIELDS[] = [],
): Promise<api.ApiResponse<api.Address<EXTRA_FIELDS>>> {
  const response = await api.api.patch.addresses({
    urlParams: { addressId: String(addressId) },
    getParams: { extra_fields: extraFields.join(',') },
    body: address,
  })

  return response.next((success) => success.body as api.Address<EXTRA_FIELDS>)
}

export function isInCountries(countries: string[]) {
  return (address: api.Address) => {
    if (countries.length === 0) {
      return true
    }
    return countries.includes(address.country)
  }
}
